import { SvgIcon } from '@mui/material';

const AirExpress = props => (
  <SvgIcon
    width='36.426'
    height='36.426'
    viewBox='0 0 36.426 36.426'
    {...props}
  >
    <g id='Group_166' data-name='Group 166' transform='translate(0 0)'>
      <g id='Group_141' data-name='Group 141' transform='translate(0 0)'>
        <path
          id='Path_40'
          data-name='Path 40'
          d='M37.158,8.158c.835-.835,4.95-5.8,3.075-7.673S33.394,2.725,32.559,3.56l-2.7,2.7C16.646,1.864,13.678,2.08,13.4,2.361l-.992.992A1.479,1.479,0,0,0,11.972,4.4q0,.073.007.148a1.477,1.477,0,0,0,.653,1.087l10.7,7.157L18.99,17.129c-.675.675-2.014.54-3.2.423-1.073-.107-2-.2-2.531.333l-1.692,1.692a1.427,1.427,0,0,0,.516,2.351,14.64,14.64,0,0,1,4.461,2.242,14.656,14.656,0,0,1,2.242,4.461,1.419,1.419,0,0,0,1.032.9,1.425,1.425,0,0,0,1.319-.386l1.692-1.692c.645-.645.523-1.693.394-2.8-.131-1.128-.267-2.294.362-2.923l4.338-4.338,7.157,10.7a1.476,1.476,0,0,0,1.087.653,1.319,1.319,0,0,0,.148.007,1.477,1.477,0,0,0,1.047-.434l.992-.992c.28-.28.5-3.247-3.9-16.465Z'
          transform='translate(-4.291 0)'
          fill='#d00127'
        />
        <path
          id='Path_41'
          data-name='Path 41'
          d='M7.3,11.53a.922.922,0,0,0-1.3,0L.27,17.258a.923.923,0,0,0,1.3,1.3L7.3,12.835a.922.922,0,0,0,0-1.3'
          transform='translate(0 -4.333)'
          fill='#d00127'
        />
        <path
          id='Path_42'
          data-name='Path 42'
          d='M11.339,21.109l2.979-2.979a.923.923,0,1,0-1.3-1.3L10.034,19.8a.923.923,0,0,0,1.3,1.3'
          transform='translate(-3.757 -6.371)'
          fill='#d00127'
        />
        <path
          id='Path_43'
          data-name='Path 43'
          d='M41.641,47.173,35.912,52.9a.923.923,0,0,0,1.305,1.3l5.728-5.728a.923.923,0,0,0-1.3-1.3'
          transform='translate(-13.716 -18.05)'
          fill='#d00127'
        />
        <path
          id='Path_44'
          data-name='Path 44'
          d='M36.391,46.162l2.979-2.979a.923.923,0,0,0-1.3-1.3l-2.979,2.979a.923.923,0,0,0,1.3,1.3'
          transform='translate(-13.398 -16.012)'
          fill='#d00127'
        />
      </g>
    </g>
  </SvgIcon>
);

export default AirExpress;
